import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class CveDetectAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'cvedetect';	
}

export default new CveDetectAPI();
